var w = function(a, f) {
  var r = a.alwaysShow, e = a.ifOverflow;
  return r && (e = "extendDomain"), e === f;
};
export {
  w as ifOverflowMatches
};
